export default __webpack_public_path__ + "static/media/atm-card.a03cda5e.png";